import type { Editor, EditorEvent, Events as RteEvents } from 'hugerte';

import type { TranslationKey } from '@change-corgi/core/i18n';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { deleteMedia } from './deleteMedia';
import { setupImageDimensions } from './imageDimensions';
import { onDropCallback } from './onDropCallback';
import { onNodeChangeCallback } from './onNodeChangeCallback';
import { setupCustomToolbar } from './setupCustomToolbar';
import { videoNodeFilter } from './videoNodeFilter';

export const setupEditor =
	(utilityContext: UtilityContext, { setErrorKey }: { setErrorKey: (errorKey: TranslationKey | null) => void }) =>
	(editor: Editor): void => {
		editor.on('drop', (event) => {
			onDropCallback({ setErrorKey, editor })(event);
		});

		// desktop
		editor.on('mouseup', (event: EditorEvent<TouchEvent | MouseEvent>) => {
			deleteMedia(event, editor);
		});

		// desktop with keyboard
		editor.on('keyup', (event: EditorEvent<KeyboardEvent>) => {
			if (event.code === 'Enter' || event.code === 'Space') {
				deleteMedia(event, editor);
			}
		});

		// mobile media
		editor.on('touchend', (event: EditorEvent<TouchEvent | MouseEvent>) => {
			deleteMedia(event, editor);
		});

		editor.on('NodeChange', (event: EditorEvent<RteEvents.NodeChangeEvent>) => {
			onNodeChangeCallback(event);
		});

		editor.on('PreInit', (_event: EditorEvent<RteEvents.EditorEventMap['PreInit']>) => {
			videoNodeFilter(editor);
		});

		editor.on('init', () => {
			setupImageDimensions(editor);
		});

		setupCustomToolbar(utilityContext, { setErrorKey, editor });
	};
